﻿import { FormType } from "@/enums";
import { useFormPropertyValueLookupProvider } from "@/providers";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

export const useProjectTypes = () => {
  const intl = useIntl();
  const { getProperty } = useFormPropertyValueLookupProvider();

  const [projectTypes, setProjectTypes] = useState([]);

  useEffect(() => {
    const projectTypeFormValues = getProperty(FormType.Intake, "projectType");

    if (!projectTypeFormValues) return;

    const projectTypes = Object.keys(projectTypeFormValues).map((id) => ({
      value: id,
      label: projectTypeFormValues[id].fallback,
    }));

    setProjectTypes(projectTypes || []);
  }, [getProperty, intl]);

  return projectTypes;
};
